/*
 * Copyright (c) 2021. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import Anchor from '../atomic/atoms/anchor/Anchor';
import { BudgetCalloutViewModel } from 'src/types/view-models/budget-callout.view.model';
import { GlyphCheck, GlyphInfo } from '@americanexpress/dls-react';
import NavigationService from '../../services/navigation.service';
import FormatService from '../../services/format.service';
import { BudgetModel } from 'src/types/budget.model';
import { DLSSize } from 'src/types/dls-size.enum';

// styles
import styles from './BudgetCallout.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

export class BudgetCallout extends Component<BudgetCalloutViewModel> {
    public override render(): ReactComponentElement<any> {
        const budget: BudgetModel = this.props.budget;
        let icon: JSX.Element;
        let budgetText: string;

        if (budget.currentlySpent < budget.monthlyAmount) {
            icon = <GlyphCheck size={DLSSize.LARGE} className={styles.checkIcon} />;
            budgetText = `Under budget by ${FormatService.formatSummary(budget.monthlyAmount - budget.currentlySpent)}`;
        } else if (budget.currentlySpent === budget.monthlyAmount) {
            icon = <GlyphCheck size={DLSSize.LARGE} className={styles.checkIcon} />;
            budgetText = 'Exactly on budget';
        } else {
            icon = <GlyphInfo size={DLSSize.LARGE} className={styles.errorIcon} />;
            budgetText = `Over budget by ${FormatService.formatSummary(budget.currentlySpent - budget.monthlyAmount)}`;
        }

        return (
            <div className={styles.expenseBarSubRow}>
                <div className={styles.left}>
                    {icon}
                    <Typography variant={TypographyVariants.SUBTEXT} className={styles.budgetText}>
                        {budgetText}
                    </Typography>
                </div>
                <Anchor
                    onClick={() => {
                        void NavigationService.goTo(
                            this.props.history,
                            '/budget/history/' + budget.groupId,
                            'Budget History'
                        );
                    }}
                    typographyProps={{
                        className: styles.budgetHistoryText,
                        variant: TypographyVariants.SUBTEXT
                    }}
                >
                    View budget history
                </Anchor>
            </div>
        );
    }
}
